import '../../../styles/restScreens.css';
import { SAVE_TARGETS } from '../../../lib/personalContacts';

// BL-177 PR D0: adding a contact in the CRM asks where it is saved. Company contacts is the default. (New people who text or email a
// company number are ALWAYS saved as Company contacts - that is the inbox's job and does not go through this choice.)
export default function SaveToChoice({ value, onChange, companyAllowed = true, disabled = false }) {
    return (
        <fieldset data-m6-layout="clients" data-m6-component="SaveToChoice" className="mb-3 rounded-lg border border-[var(--surface-border)] bg-[var(--surface-sunken)] p-3" data-testid="save-to-choice">
            <legend className="px-1 text-xs font-semibold text-[var(--ink-muted)]">Save to</legend>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
                {SAVE_TARGETS.map((target) => {
                    const off = disabled || (target.key === 'company' && !companyAllowed);
                    return (
                        <label key={target.key} className={`flex items-start gap-2 text-sm ${off ? 'opacity-50' : ''}`}>
                            <input
                                type="radio"
                                name="save-contact-to"
                                value={target.key}
                                checked={value === target.key}
                                disabled={off}
                                onChange={() => onChange(target.key)}
                                className="mt-1"
                            />
                            <span>
                                <span className="font-medium text-[var(--ink)]">{target.label}</span>
                                <span className="block text-xs text-[var(--ink-muted)]">{target.hint}</span>
                            </span>
                        </label>
                    );
                })}
            </div>
        </fieldset>
    );
}
